export const exit = {
  exit: {
    shape:
      '<path d="M9.8125 2.375L12.3125 2.375C12.644 2.375 12.962 2.5067 13.1964 2.74112C13.4308 2.97554 13.5625 3.29348 13.5625 3.625L13.5625 12.375C13.5625 12.7065 13.4308 13.0245 13.1964 13.2589C12.962 13.4933 12.644 13.625 12.3125 13.625L9.8125 13.625" stroke="#25282B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.4375 4.875L2.3125 8L5.4375 11.125" stroke="#25282B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.3125 8L9.8125 8" stroke="#25282B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>',
    viewBox: [0, 0, 16, 16],
  },
};
